module.exports = __webpack_public_path__ + "static/media/400389_01.8d97faf4.png";